<template>
  <div style="position: relative">
    <el-menu :default-active="elMenus.defaultActive" background-color="#374151" text-color="#fff" active-text-color="#fff" class="el-menu-vertical-demo"
      @open="handleOpen" @close="handleClose" :unique-opened="true" :collapse="elMenus.isCollapse && !isCollapse">
      <!-- logo -->
      <!-- <div class="logo flexNormal">
        <h3 class="nowrap" v-if="!elMenus.isCollapse">设备管理成熟度评估系统</h3>
      </div> -->
      <!-- 以下是单层级别 -->
      <el-menu-item @click="handleSelect(menu)" :index="menu.id" v-for="(menu, index) in elMenus.data" :key="index">
        <div class="flexStart">
          <div style="margin-right:5px">
            <i :class="menu.icon"></i>
            <span slot="title">{{ menu.name }}</span>
          </div>
          <el-badge :ref="menu.id" :hidden="!(menu.ifMsg && menu.num_msg > 0)" :value="menu.num_msg" :max="999"> </el-badge>
        </div>

      </el-menu-item>

      <!-- 以下是多层级别，需要可以打开 -->
      <!-- <span v-for="(menu, index) in elMenus.data" :key="index">
        <div class="meunLine" v-if="index == 8"></div>
        <el-submenu :index="menu.id" @click="handleSelect(menu)">
          <template slot="title">
            <i :class="menu.icon"></i>
            <el-badge :hidden="!(menu.ifMsg && menu.num_msg)" is-dot class="badgeDot_menu"> </el-badge>
            <span class="titleSpan" v-show="!elMenus.isCollapse" style="font-size: 16px"> {{ menu.name }}</span>
          </template>
          <el-menu-item-group v-if="menu.child && menu.child.length > 0">
            <el-menu-item v-for="(child, c) in menu.child" :key="c" :index="child.id" style="font-size: 14px" @click="handleSelect(child)">
              <span>&nbsp;&nbsp;&nbsp;&nbsp;{{ child.name }}&nbsp;</span>
              <el-badge :ref="child.id" :hidden="!(child.ifMsg && child.num_msg > 0)" :value="child.num_msg" :max="99" @click.native="msgClick(child, $event)"> </el-badge>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </span> -->
    </el-menu>
    <div class="fold flexNormal" v-if="!isCollapse" @click="elMenus.isCollapse = !elMenus.isCollapse">
      <i :class="elMenus.isCollapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      elMenus: this.value,
    };
  },
  props: ['value', 'isCollapse'],
  watch: {
    value: {
      handler: function (newVal, oldVal) {
        this.elMenus = newVal;
      },
      deep: true,
    },
  },
  created() { },
  mounted() { },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleSelect(key) {
      this.$emit('select', key);
    },
    msgClick(item, event) {
      event.stopPropagation();
      this.$emit('select', item, true);
    },
  },
};
</script>
<style lang="less" scoped>
::-webkit-scrollbar {
  width: 0;
}

.meunLine {
  margin: 10px auto;
  height: 1px;
  width: 90%;
  background-color: #cccccc8a;
}

.el-menu--collapse {
  min-height: calc(100vh - 60px);
  max-height: calc(100vh - 60px);
  overflow: auto;
}

.el-menu-vertical-demo {
  position: relative;

  &:not(.el-menu--collapse) {
    width: 236px;
    min-height: calc(100vh - 60px);
    max-height: calc(100vh - 60px);
    overflow: auto;
  }

  /deep/.is-active {
    background-color: @status_blue !important;
  }

  /deep/.el-submenu__title,
  /deep/.el-menu-item {
    font-size: 15px;
    font-weight: 500;
  }

  .logo {
    height: 80px;
    color: #fff;
  }
}

.fold {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: @theme_color;
  border: 1px solid #fff;
  color: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -15px;
  z-index: 99;
  cursor: pointer;
}

/*子菜单样式*/
/deep/.el-menu-item {
  background: #4f5e74 !important; //#465264
}

/*子菜单悬浮样式*/
/deep/.el-menu-item:hover {
  color: white !important;
  background: #3e7bfa !important;
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  #homePage {
    display: flex;
    flex-direction: column;
  }

  .pc {
    display: none;
  }

  // 菜单的高度 在 移动端 需要变成自适应
  .el-menu-vertical-demo {
    &:not(.el-menu--collapse) {
      height: auto;
      min-height: auto;
    }

    .titleSpan {
      display: inline-block !important;
    }
  }
}
</style>
